export const DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm A"; 